export default el => {
    el.addEventListener('click', e => {
        const btn = e.target.closest('.js-header-submenu-btn');
        if (btn) {
            btn.parentNode.classList.toggle('active');
        }
    });
}